import React, { useState, useEffect, Fragment } from 'react';
import { Form, Button, Card, Row, Col } from 'react-bootstrap';
import { Table, Popconfirm, message, Select } from 'antd';
import { submitForm, deleteReturn, updateReturns } from '../../../services/UploadService';
import { getReturns,getReturnsStatus, getAllAdminIECsService, GetReturnsDataService } from '../../../services/FileDataService';
import ReturnsInputModal from './ReturnsDataEntryInputModal';
import { CSVLink } from "react-csv";
import { formatDateTime } from '../../../utilities/utils';
import { SERVER_URL } from "../../../const";

import moment from 'moment';
import 'react-dropzone-uploader/dist/styles.css';
import { cleanFilename, getTodaysDate } from '../../../utilities/utils';
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';

const edit = ` <svg width="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M11.4925 2.78906H7.75349C4.67849 2.78906 2.75049 4.96606 2.75049 8.04806V16.3621C2.75049 19.4441 4.66949 21.6211 7.75349 21.6211H16.5775C19.6625 21.6211 21.5815 19.4441 21.5815 16.3621V12.3341" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
<path fillRule="evenodd" clipRule="evenodd" d="M8.82812 10.921L16.3011 3.44799C17.2321 2.51799 18.7411 2.51799 19.6721 3.44799L20.8891 4.66499C21.8201 5.59599 21.8201 7.10599 20.8891 8.03599L13.3801 15.545C12.9731 15.952 12.4211 16.181 11.8451 16.181H8.09912L8.19312 12.401C8.20712 11.845 8.43412 11.315 8.82812 10.921Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
<path d="M15.1655 4.60254L19.7315 9.16854" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
</svg>`;

const deleteIcon = ` <svg width="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="currentColor">
<path d="M19.3248 9.46826C19.3248 9.46826 18.7818 16.2033 18.4668 19.0403C18.3168 20.3953 17.4798 21.1893 16.1088 21.2143C13.4998 21.2613 10.8878 21.2643 8.27979 21.2093C6.96079 21.1823 6.13779 20.3783 5.99079 19.0473C5.67379 16.1853 5.13379 9.46826 5.13379 9.46826" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
<path d="M20.708 6.23975H3.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
<path d="M17.4406 6.23973C16.6556 6.23973 15.9796 5.68473 15.8256 4.91573L15.5826 3.69973C15.4326 3.13873 14.9246 2.75073 14.3456 2.75073H10.1126C9.53358 2.75073 9.02558 3.13873 8.87558 3.69973L8.63258 4.91573C8.47858 5.68473 7.80258 6.23973 7.01758 6.23973" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
</svg>`;

const ReturnsFormComponent = (props) => {
  const [show, setShow] = useState(false);
  // Required fields turn red only after a Submit attempt left them empty.
  const [submitAttempted, setSubmitAttempted] = useState(false);
  const [editData, setEditData] = useState(null);
  const [formValues, setFormValues] = useState({
    description: '',
    return_date: '',
    tenure: '',
    trigger_rate: '8',
    upload_docs: '',
    return_submitted: false,
    ice_name: '',
    iec_no: '',
  });
  const [messageApi, contextHolder] = message.useMessage();
  const [IECOptions, setIECOptions] = useState([]);
  const [selectedIEC, setSelectedIEC] = useState(
    (localStorage.getItem('role') === 'superadmin' || localStorage.getItem('role') === 'group_head')
      ? null
      : localStorage.getItem('iec_no')
  );
  const [iecName, setIECName] = useState(
    (localStorage.getItem('role') === 'superadmin' || localStorage.getItem('role') === 'group_head')
      ? ''
      : localStorage.getItem('name')
  );
  const [userRole, setUserRole] = useState(localStorage.getItem('role'))
  const [tenureOptions, setTenureOptions] = useState([]);
  const [fileNames, setFileNames] = useState([]);
  const [files, setFiles] = useState([])
  const [returns, setReturns] = useState([]);
  const [tenureRate, setTenureRate] = useState("8");
  const [csvData, setCsvData] = useState([]);

  const handleShow = () => setShow(true);
  const handleClose = () => {
    fetchReturns()
    setShow(false);
  };

  useEffect(() => {

    if (returns?.length) {
      const newData = returns.map((item) => ({
        iec_no: item.iec_no || "",
        description: item.description || "",
        return_date: item.return_date || "",
        tenure: item.tenure || "",
        trigger_rate: item.trigger_rate || "",
        return_submitted: item.return_submitted ? "Yes" : "No",
        file_path: item.file_path?.join(", ") || "",  // Join multiple file paths with commas
        created_at: item.created_at || "",
        updated_at: item.updated_at || "",
        email_sent_at: item.email_sent_at || "",
      }));

      setCsvData(newData);
    }
  }, [returns]);


  const handleInputChange = (e) => {
    const { name, value, files, checked, type } = e.target;

    if (files) {

      const selectedFiles = Array.from(files); // Convert FileList to Array

      const allFiles = selectedFiles.filter((file) =>
        file.name
      );

      // Update state with valid files and display their names
      setFormValues({ ...formValues, upload_docs: files });
      setFiles(files)
      setFileNames(allFiles.map((file) => file.name)
      );
    }

    if (type === 'checkbox') {
      setFormValues({
        ...formValues,
        [name]: checked,
      });
    } else {

      setFormValues({
        ...formValues,
        [name]: value,
      });
    }
  }

  const handleIECSelection = (val) => {
    if (val) {
      let iec_no = val.split(";")[0];
      let iec_name = val.split(";")[1];
      setSelectedIEC(iec_no)
      setIECName(iec_name)
      setFormValues({
        ...formValues,
        ice_name: iec_name,
        iec_no: iec_no
      })
    }
    else {
      setSelectedIEC(null);
      setIECName('');
      setFormValues({
        ...formValues,
        ice_name: '',
        iec_no: ''
      })
    }
  }

  const getAdminIEC = async () => {
    const token = localStorage.getItem('token');
    const response = await getAllAdminIECsService(token);

    if (response && response.data) {
      let i = 0;
      const options = response.data.map(item => ({
        value: `${item.iec_no};${item.fullname}`,
        label: `${item.iec_no} (${item.fullname})`,
        key: i++,
      }));

      setIECOptions(options);
    }

  }

  const errorFunction = (content) => {
    messageApi.open({
      type: 'error',
      content: content,
    });
  };

  const successFunction = (content) => {
    messageApi.open({
      type: 'success',
      content: content,
    });
  };


  useEffect(() => {
    const fetchOptions = async () => {
      const options = [
        { value: "One Time", label: "One Time" }, 
        { value: "Monthly", label: "Monthly" }, 
        { value: "Quarterly", label: "Quarterly" },
        { value: "Half Yearly", label: "Half Yearly" },
        { value: "Yearly", label: "Yearly" },
        { value: "Annual", label: "Annual" },
        { value: "2 Yearly", label: "2 Yearly" },
        { value: "3 Yearly", label: "3 Yearly" },
        { value: "4 Yearly", label: "4 Yearly" },
        { value: "5 Yearly", label: "5 Yearly" },
        { value: "6 Yearly", label: "6 Yearly" },
      ];
      setTenureOptions(options);
    };

    fetchOptions();
  }, []);

  const handleSubmit = async () => {
    try {
      setSubmitAttempted(true);

      const formData = new FormData();
      
      formData.append('description', String(formValues.description));
      
      formData.append('return_date', formValues.return_date);
      
      formData.append('tenure', formValues.tenure);
      
      formData.append('trigger_rate', formValues.trigger_rate);
      
      formData.append('return_submitted', formValues.return_submitted);
      
      formData.append('iec_no', formValues?.iec_no?.length === 0 ? selectedIEC : formValues?.iec_no);
      
      if (files.length > 0) {
        for (let i = 0; i < files.length; i++) {
          formData.append('upload_docs', files[i]);

        }
      }

      const isValid = Object.entries(formData).every(([key, value]) => {
        // Exclude 'purpose' key from validation
        if (key !== 'purpose') {
          return value !== null && value.trim() !== '';
        }
        return true; // Skip validation for 'purpose' key
      });

      if (!isValid) {
        errorFunction("Please enter all the required fields");
        return;
      }

      if (!selectedIEC || selectedIEC == '' || !files) {
        errorFunction("Please select IEC");
        return
      }


      // Append any additional data or files if needed
      const token = localStorage.getItem('token');
      // Make the API call
      const response = await submitForm(formData, token)
      if (response) {

        if (response.data) {
          // success
          setFormValues({
            description: '',
            return_date: '',
            tenure: '',
            trigger_rate: '',
            upload_docs: '',
            return_submitted: false,
            ice_name: '',
            iec_no: '',
          });
          setSubmitAttempted(false);
          successFunction("Success");
        }
        else {
          throw new Error('Error submitting form data')
        }
      }
      else {
        throw new Error('Error submitting form data')
      }


    } catch (error) {
      // error
      errorFunction(error?.message ? error?.message : error);
    } finally {
      fetchReturns();
    }
  }

  const deleteReturns = async (record) => {
    const id = record.returns_id;
    // Append any additional data or files if needed
    const token = localStorage.getItem('token');
    try {
      await deleteReturn(id, token);
      fetchReturns();
      message.success('Deleted successfully');
    }
    catch (error) {
      console.log(error);
      message.error("Error")
    }
  }
  const handleApprovedChange = async (record, checked) => {
    const id = record.returns_id;
    const token = localStorage.getItem('token');
    try {
      const formData = new FormData();
      formData.append('is_approved', checked);
      await updateReturns(id, formData, token);
      fetchReturns();
      message.success('Status updated successfully');
    } catch (error) {
      console.log(error);
      message.error("Error updating status");
    }
  }
  const editReturnsRecord = (record) => {
    const r = {
      ...record,
      upload_docs: record?.file_path ?? []
    }
    delete r.file_path
    setEditData(r);
    handleShow();
  }


  const columns = [
    {
      title: "Action",
      dataIndex: "iconAction",
      width: 80,
      fixed: 'left',
      render: (text, record) => {
        return (
          <div class="flex align-items-center list-user-action">
            <a onClick={() => editReturnsRecord(record)} class="btn btn-sm btn-icon btn-warning" data-toggle="tooltip" data-placement="top" title="" data-original-title="Add" to="#">
              <span class="btn-inner" dangerouslySetInnerHTML={{ __html: edit }}>
 
              </span>
            </a>
            &nbsp;
            <Popconfirm
              title="Delete the return"
              description="Are you sure to delete this return?"
              onConfirm={() => deleteReturns(record)}
              okText="Yes"
              cancelText="No"
            >
              <a class="btn btn-sm btn-icon btn-danger" data-toggle="tooltip" data-placement="top" title="" data-original-title="Delete" to="#">
                <span class="btn-inner" dangerouslySetInnerHTML={{ __html: deleteIcon }}>
 
                </span>
              </a>
            </Popconfirm>
          </div>
        );
      },
    },
    {
      title: "IEC/Company",
      dataIndex: "iec_no",
      width: 250,
      render: (text, record) => (
        <span>{text} - {record.fullname}</span>
      )
    },
    {
      title: "Description",
      dataIndex: "description",
      width: 250,
    },
    {
      title: "Return date",
      dataIndex: "return_date",
      width: 130,
    },
    {
      title: "Tenure",
      dataIndex: "tenure",
      width: 120,
    },
    {
      title: "Trigger Rate",
      dataIndex: "trigger_rate",
      width: 120,
    },
    {
      title: "Return Submitted",
      dataIndex: "return_submitted",
      width: 180,
      render: (text, record) => {
        // return <Form.Check
        //   name="return_submitted"
        //   type="checkbox"
        //   checked={Boolean(text)}
        //   disabled={true}
        //   value={Boolean(text)}
        // />
        return (
          <>
            {Boolean(text) === true ? "Return submitted" : null} {text}
          </>
        );
      },
    },
    {
      title: "Documents",
      dataIndex: "file_path",        
      width: 250,
      render: (text) => {
        const token = localStorage.getItem("token"); // Fetch the token from storage (adjust as per your storage mechanism)
 
        const handleDownload = async (fileName) => {
          try {
            const response = await fetch(`${SERVER_URL}/download/${fileName}`, {
              method: "GET",
              headers: {
                Authorization: `Bearer ${token}`,
              },
            });
 
            if (!response.ok) {
              throw new Error("Failed to download file");
            }
 
            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            a.download = fileName;
            document.body.appendChild(a);
            a.click();
            window.URL.revokeObjectURL(url);
            document.body.removeChild(a);
          } catch (error) {
            console.error("Download failed:", error);
          }
        };
 
        return (
          <>
            {Array.isArray(text) &&
              text.map((fileName) => {
                const formatted_file_name = cleanFilename(fileName);
                return (
                  <button
                    key={fileName}
                    onClick={() => handleDownload(fileName)}
                    style={{
                      marginRight: "8px",
                      color: "#007bff",
                      textDecoration: "underline",
                      background: "none",
                      border: "none",
                      cursor: "pointer",
                    }}
                  >
                    {formatted_file_name}
                  </button>
                );
              })}
          </>
        );
      },
    },
    {
      title: "Created At",
      dataIndex: "created_at",
      width: 130,
      render: (text) => {
        return text ? moment(text).format('DD-MM-YYYY') : '-';
      },
    },
    {
      title: "Updated At",
      dataIndex: "updated_at",
      width: 130,
      render: (text) => {
        return text ? moment(text).format('DD-MM-YYYY') : '-';
      },
    },
    {
      title: "Approved",
      dataIndex: "is_approved",
      width: 100,
      render: (text, record) => {
        return (
          <Form.Check
            type="checkbox"
            checked={Boolean(text)}
            onChange={(e) => handleApprovedChange(record, e.target.checked)}
          />
        );
      },
    },
    {
      title: "Email Sent At",
      dataIndex: "email_sent_at",
      width: 130,
      render: (text) => {
        // Format the date to only show the date part, not the time
        return text ? moment(text).format('DD-MM-YYYY') : '-';
      },
    },

  ];

  const fetchReturns = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await GetReturnsDataService(token, "all");
      //const response = await getReturnsStatus(token);
      setReturns([]);
      if (response) {
        if (response.data) {
          setReturns(response.data);
        }
      }
    }
    catch (error) {
      console.log(error);
    }

  }

  const csvHeaders = [
    { label: "Description", key: "description" },
    { label: "IEC", key: "iec_no" },
    { label: "Return date", key: "return_date" },
    { label: "Tenure", key: "tenure" },
    { label: "Trigger Rate", key: "trigger_rate" },
    { label: "Return Submitted", key: "return_submitted"},
    { label: "Created AT", key: "created_at" },
    { label: "Documents", key: "file_path" },
    { label: "Updated AT", key: "updated_at" },
    { label: "Email Sent AT", key: "email_sent_at" },
  ];

  useEffect(() => {
    setFormValues({
      description: '',
      return_date: '',
      tenure: '',
      trigger_rate: '',
      upload_docs: '',
      return_submitted: false,
      ice_name: '',
      iec_no: '',
    });
    getAdminIEC();
    fetchReturns();
  }, [props.title]);

  const exportToExcel = async () => {
    try {
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet('Returns');

      worksheet.columns = [
        { header: 'IEC / Company', key: 'iec_no', width: 25 },
        { header: 'Description', key: 'description', width: 30 },
        { header: 'Return Date', key: 'return_date', width: 15 },
        { header: 'Tenure', key: 'tenure', width: 15 },
        { header: 'Trigger Rate', key: 'trigger_rate', width: 15 },
        { header: 'Return Submitted', key: 'return_submitted', width: 18 },
        { header: 'Documents', key: 'file_path', width: 30 },
        { header: 'Created At', key: 'created_at', width: 18 },
        { header: 'Updated At', key: 'updated_at', width: 18 },
        { header: 'Email Sent At', key: 'email_sent_at', width: 18 },
      ];

      worksheet.getRow(1).eachCell((cell) => {
        cell.font = { bold: true, color: { argb: 'FFFFFF' } };
        cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: '1E3A8A' } };
        cell.alignment = { vertical: 'middle', horizontal: 'center' };
      });

      returns.forEach((item) => {
        worksheet.addRow({
          iec_no: `${item.iec_no || ''} ${item.fullname ? '- ' + item.fullname : ''}`,
          description: item.description || '',
          return_date: item.return_date || '',
          tenure: item.tenure || '',
          trigger_rate: item.trigger_rate || '',
          return_submitted: item.return_submitted ? 'Yes' : 'No',
          file_path: Array.isArray(item.file_path) ? item.file_path.map((f) => cleanFilename(f)).join(', ') : '',
          created_at: item.created_at ? moment(item.created_at).format('DD-MM-YYYY') : '',
          updated_at: item.updated_at ? moment(item.updated_at).format('DD-MM-YYYY') : '',
          email_sent_at: item.email_sent_at ? moment(item.email_sent_at).format('DD-MM-YYYY') : '',
        });
      });

      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });
      saveAs(blob, `Lucrative's CIP DSS - Standard Compliance Returns as on ${getTodaysDate()}.xlsx`);
    } catch (err) {
      console.error('Error exporting returns to excel:', err);
      message.error('Failed to export Excel report');
    }
  };

  return (
    <Fragment>
      {contextHolder}
      <Card>
        <Card.Body>
          <Card.Title>
            {props.title}

            {userRole && (userRole === 'superadmin' || userRole === 'group_head') && (
              <Select
                focus
                showSearch
                placeholder="Select IEC"
                filterOption={(input, option) =>
                  (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                }
                onChange={handleIECSelection}
                allowClear
                options={IECOptions}
                style={{ width: '300px', float: 'right' }}
              />
            )}
          </Card.Title>
          <hr className="hr-horizontal" />
          <h6 style={{ display: 'inline-block', textAlign: 'center' }}>
            <b>{iecName}</b>
          </h6>
          &nbsp;&nbsp;&nbsp;
          <strong>{selectedIEC}</strong>
          <hr className="hr-horizontal" />

          <Form>
            <Form.Group as={Row} className="mb-3" controlId="description">
              <Form.Label column sm="2">
                Description*
              </Form.Label>
              <Col sm="10">
                <Form.Control
                  required
                  type="text"
                  name="description"
                  placeholder="Enter Description"
                  value={formValues.description}
                  onChange={handleInputChange}
                  style={submitAttempted && !(formValues.description) ? { border: '1px solid var(--cip-danger)' } : undefined}
                />
              </Col>
            </Form.Group>

            <Form.Group as={Row} className="mb-3" controlId="return_date">
              <Form.Label column sm="2">
                Return date*
              </Form.Label>
              <Col sm="4">
                <Form.Control
                  required
                  type="date"
                  name="return_date"
                  placeholder="Enter Return date"
                  value={formValues.return_date}
                  onChange={handleInputChange}
                  style={submitAttempted && !(formValues.return_date) ? { border: '1px solid var(--cip-danger)' } : undefined}
                />
              </Col>
              <Form.Label column sm="2">
                Tenure*
              </Form.Label>

              <Col sm="4">
                <Form.Control
                  required
                  as="select"
                  name="tenure"
                  placeholder="Enter Tenure Type"
                  value={formValues.tenure}
                  onChange={handleInputChange}
                  style={submitAttempted && !(formValues.tenure) ? { border: '1px solid var(--cip-danger)' } : undefined}
                >
                  <option value="" disabled>
                    Select Tenure
                  </option>
                  {tenureOptions.map((option) => (
                    <option key={option.value} value={option.value}>
                      {option.label}
                    </option>
                  ))}
                </Form.Control>
              </Col>
            </Form.Group>

            <Form.Group as={Row} className="mb-3" controlId="trigger_rate">
              <Form.Label column sm="2">
                Alert trigger rate in days*
              </Form.Label>
              <Col sm="4">
                <Form.Control
                  required
                  name="trigger_rate"
                  placeholder="Enter Trigger rate"
                  value={formValues.trigger_rate}
                  onChange={handleInputChange}
                  type="number"
                  style={submitAttempted && !(formValues.trigger_rate) ? { border: '1px solid var(--cip-danger)' } : undefined}
                />
              </Col>
            </Form.Group>

            <Form.Group as={Row} className="mb-3" controlId="upload_docs">
              <Form.Label column sm="2">
                Upload docs
              </Form.Label>
              <Col sm="10">
                <Form.Control
                  required
                  multiple
                  type="file"
                  name="upload_docs"
                  accept=".pdf, .xls, .xlsx, .jpeg, .png"
                  value={formValues.upload_docs}
                  onChange={handleInputChange}
                  style={submitAttempted && !(formValues.upload_docs.length) ? { border: '1px solid var(--cip-danger)' } : undefined}
                />
              </Col>
              <Col sm="10">
                <div style={{ marginTop: '10px' }}>
                  {fileNames.length > 0 ? (
                    <p>{fileNames.join(', ')}</p>
                  ) : (
                    <p>No files selected</p>
                  )}
                </div>
              </Col>
            </Form.Group>

            <Button variant="primary" className="cip-action-btn" onClick={handleSubmit} style={{ float: 'right' }}>
              Submit
            </Button>
          </Form>
        </Card.Body>
      </Card>

      <div className="table-responsive">
        {returns.length > 0 && (
          <button
            style={{ float: 'right', marginBottom: '10px' }}
            className="btn btn-primary cip-action-btn"
            onClick={exportToExcel}
          >
            Export to Excel
          </button>
        )}
        <ReturnsInputModal
          errorFunction={errorFunction}
          userRole={userRole}
          selectedIEC={selectedIEC}
          selectedIECName={iecName}
          IECOptions={IECOptions}
          title={props.title}
          handleClose={handleClose}
          open={show}
          data={editData}
          tenureOptions={tenureOptions}
        />
        <Table columns={columns} dataSource={returns} scroll={{ x: 'max-content' }} />
      </div>
    </Fragment>
  );
};

export default ReturnsFormComponent;
